import { createAction } from 'redux-actions'
import axios from 'axios'
import config from '../../config'
import format from 'date-fns/format'
import { getAppDomain, getAppPDV } from '../app/selectors'
import { getBookingServices } from '../booking/selectors'

export const availabilitiesSetDays = createAction('AVAILABILITIES:SETDAYS')
export const availabilitiesStartLoading = createAction(
  'AVAILABILITIES:STARTLOADING'
)
export const availabilitiesSuccessLoading = createAction(
  'AVAILABILITIES:SUCCESSLOADING'
)
export const availabilitiesErrorLoading = createAction(
  'AVAILABILITIES:ERRORLOADING'
)

export const setAvailabilitiesFilter = createAction('AVAILABILITIES:SETFILTER')

const formatServicesToQueryString = services => {
  return services.map(service => `prId=${service.id}`).join('&')
}

const computeURL = (domain, pdvID, startDay, endDay, services) => {
  const baseUrl = `${
    config.apiUrl
  }appuntamenti-web/agenda?domain=${domain}&dataDa=${format(
    startDay,
    'YYYY-MM-DD'
  )}&dataA=${format(endDay, 'YYYY-MM-DD')}&${formatServicesToQueryString(
    services
  )}`

  if (pdvID === null) return baseUrl
  return `${baseUrl}&pdv=${pdvID}`
}

export const fetchAvailabilitiesForMonth = (startDay, endDay) => async (
  dispatch,
  getState
) => {
  try {
    const domain = getAppDomain(getState())
    const pdvID = getAppPDV(getState())

    const services = getBookingServices(getState())

    const result = await axios.get(
      computeURL(domain, pdvID, startDay, endDay, services)
    )
    dispatch(availabilitiesSetDays(result.data))
    dispatch(availabilitiesSuccessLoading())
  } catch (e) {
    dispatch(availabilitiesErrorLoading(e))
  }
}
